export const environment = {
  production: true,
  api_base_url: 'https://apidev.rdvexpress.idzconsulting.fr'
};
